// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownBoldExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-bold.svg?react';
import { createIcons } from '../../Icon';
const MarkdownBoldIcon = /* @__PURE__ */ createIcons('MarkdownBold', {
    extended: MarkdownBoldExtended
});
MarkdownBoldIcon.supportedTypes = [
    'extended'
];
MarkdownBoldIcon.category = 'markdown';
export default MarkdownBoldIcon;
